import { CasinoTypeUnion, INormalizedGame } from 'libs/games/src/types';
import { GamesStorageType, IFeedCategoriesNormalized } from '../../types';

type NormalizedCategoriesArg = {
  categories: IFeedCategoriesNormalized;
  games: Record<string, INormalizedGame>;
  launchIdToGameId: Record<number, string>;
};

type PlexGetCategoriesStatePreparator = (args: {
  normalizedCategories: NormalizedCategoriesArg;
  state: GamesStorageType;
  casinoType?: CasinoTypeUnion;
  feedName?: string;
}) => GamesStorageType;

export const plexGetCategoriesStatePreparator: PlexGetCategoriesStatePreparator =
  ({ normalizedCategories, state, casinoType, feedName }) => {
    return {
      ...state,
      ...(casinoType
        ? {
            lobbies: {
              ...state.lobbies,
              [casinoType]: {
                ...state.lobbies[casinoType],
                categories: normalizedCategories.categories,
                isCategoriesLoading: false,
                isCategoriesLoaded: true
              }
            }
          }
        : {}),
      games: {
        ...state.games,
        data: {
          ...state.games.data,
          ...normalizedCategories.games
        },
        launchIdToGameId: {
          ...state.games.launchIdToGameId,
          ...normalizedCategories.launchIdToGameId
        },
        ids: [
          ...new Set(
            Object.keys({
              ...state.games.data,
              ...normalizedCategories.games
            })
          )
        ]
      },
      // feed stuf below:
      ...(feedName && !casinoType
        ? {
            feeds: {
              ...state.feeds,
              [feedName]: {
                categories: normalizedCategories.categories,
                isLoading: false,
                isLoaded: true
              }
            }
          }
        : {})
    };
  };
